import React, { Component } from 'react';
import { ButtonGroup, Button, Glyphicon } from 'react-bootstrap';
import '../../content/css/IconButtonGroup.css';

export default class IconButtonGroup extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleClicked = this.handleClicked.bind(this);
    }

    renderButtons() {
        let self = this;
        return this.props.buttons.map((btn, i) => (
            <Button bsSize="xsmall" className="icon-btn" onClick={() => self.handleClicked(btn.name)}>
                <Glyphicon glyph={btn.glyph} /> {btn.text}
            </Button>
        ));
    }

    handleClicked(name) {
        this.props.onClick(name);
    }

    render() {
        return (
            <div className="icon-btn-group">
                <ButtonGroup vertical>
                    {this.renderButtons()}
                </ButtonGroup>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Misc/IconButtonGroup.js